import {
    accountType,
    country,
    organizationId,
} from 'configuration/fieldCreators/orgFacts'

export const SPECIAL_ORG_FACT_GROUP_BY_COLUMNS = [
    organizationId({
        dataIndex: ['organization_id'],
    }),
    country({ dataIndex: ['country'] }),
    accountType({
        dataIndex: ['account_type'],
    }),
]
